import { render, staticRenderFns } from "./MovieHot.vue?vue&type=template&id=75c3f0d6&"
import script from "./MovieHot.vue?vue&type=script&lang=js&"
export * from "./MovieHot.vue?vue&type=script&lang=js&"
import style0 from "./MovieHot.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports